import { ContentChild, Directive, inject, Type } from '@angular/core';

import { TemplateResolver } from '../../template-resolver';
import { DEFAULT_LIST_ITEM_COMPONENT, Select2DefaultItemComponent } from './list-item.component';
import { Select2ListItemDirective } from './list-item.directive';

@Directive({
  standalone: true,
  selector: 'rt-select2-list-item-resolver',
})
export class ListItemResolverDirective extends TemplateResolver<
  Select2ListItemDirective<any>,
  { optional: false }
> {
  @ContentChild(Select2ListItemDirective)
  public override contentDirective?: Select2ListItemDirective<any>;
  public override injectedComponent = <Type<Select2DefaultItemComponent>>(
    (<unknown>inject(Select2DefaultItemComponent, { optional: true }))
  );
  public override defaultComponent =
    inject(DEFAULT_LIST_ITEM_COMPONENT, { optional: true }) ?? Select2DefaultItemComponent;
}
